import { PromptTag } from "components/prompts/PromptSearch";
import { PresetPromptDto } from "dtos/frankenstories/prompts/PresetPromptDto";
import { useState, useCallback } from "react";
import { PresetsApiServiceType } from "services/PresetsApiService";

export const usePromptLibrary = (props: { presetsApiService: PresetsApiServiceType }) => {
    const { presetsApiService } = props;
    const { getPresetSearch, getPresetsTags } = presetsApiService;

    // global prompt search result
    const [promptSearchResults, setPromptSearchResults] = useState<Array<PresetPromptDto>>();

    const getPromptSearchResults = useCallback(async () => {
        // return saved data if it already exists
        if (promptSearchResults) {
            return promptSearchResults;
        }

        const x = await getPresetSearch();

        const { prompts } = x;

        setPromptSearchResults(prompts);

        return prompts;
    }, [getPresetSearch, promptSearchResults]);

    // global prompt tags
    const [promptSearchTags, setPromptSearchTags] = useState<Array<PromptTag>>();

    const getPromptSearchTags = useCallback(async () => {
        // return saved data if it already exists
        if (promptSearchTags) {
            return promptSearchTags;
        }

        const x = await getPresetsTags();

        const newData: Array<PromptTag> = [];

        let id = 1;

        for (const tag of x.tags) {
            newData.push({
                id,
                name: tag.name,
                tagId: tag.id,
                tagType: "tag",
            });

            id++;
        }

        for (const tag of x.programs) {
            newData.push({
                id,
                name: tag.name,
                tagId: tag.id,
                tagType: "program",
            });

            id++;
        }

        for (const tag of x.topics) {
            newData.push({
                id,
                name: tag.name,
                tagId: tag.id,
                tagType: "topic",
            });

            id++;
        }

        setPromptSearchTags(newData);

        return newData;
    }, [getPresetsTags, promptSearchTags]);

    return {
        getPromptSearchTags,
        getPromptSearchResults,
    };
};
